import { render, staticRenderFns } from "./FloatingBar.vue?vue&type=template&id=8689a72c&scoped=true&"
import script from "./FloatingBar.vue?vue&type=script&lang=js&"
export * from "./FloatingBar.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBar.vue?vue&type=style&index=0&id=8689a72c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8689a72c",
  null
  
)

export default component.exports